import { filterHtmlModuleTypeTextMap } from '@utils/htmlModuleConfig';

export const modelIptDataLeft = [
  {
    type: 'Input',
    label: 'Project Name',
    name: 'projectName',
    value: '',
    required: true,
    hasIcon: false,
  },
];

const commonAttribution = {
  type: 'Input',
  style: { width: '46%' },
};

export const individualBuyerData = [
  {
    type: 'Div',
    text: `Please enter information about the `,
    companyName: 'Client Company.',
    name: 'SUBONEdiv',
    style: {
      marginBottom: '1.563rem',
      color: '#DBDBDB',
      fontFamily: 'Helvetica Neue,Arial',
      fontSize: '1.375rem',
    },
  },
  {
    type: 'Input',
    label: 'Company Name',
    name: 'SUBONEname',
    required: true,
    message: 'Company Name is required',
    style: { width: '46%' },
  },
  {
    label: 'Parent Company',
    name: 'SUBONEparentCompany',
    ...commonAttribution,
  },
  {
    label: 'Company Website',
    name: 'SUBONEcompanyWebsite',
    required: true,
    message: 'Company Website is required',
    ...commonAttribution,
  },
  {
    label: 'Company Description',
    name: 'SUBONEdescription',
    ...commonAttribution,
    type: 'textArea',
  },
  {
    label: 'Industry',
    name: 'SUBONEindustry',
    ...commonAttribution,
  },
  {
    label: 'Headquarters',
    name: 'SUBONEheadquarters',
    ...commonAttribution,
  },
  {
    label: 'Incorporation Year',
    name: 'SUBONEincorporationDate',
    ...commonAttribution,
  },
  {
    label: 'Employee Headcount',
    name: 'SUBONEemployeeHeadcount',
    pattern: /^[0-9,]*$/,
    message: 'Please input correct number',
    ...commonAttribution,
  },
  {
    label: 'Estimated Total Revenue ($ US)',
    name: 'SUBONEestimatedTotalRevenue',
    pattern: /^[0-9,]*$/,
    message: 'Please input correct number',
    ...commonAttribution,
  },

  {
    label: 'Estimated Market Cap ($ US)',
    name: 'SUBONEestimatedMarketCap',
    type: 'Input',
    pattern: /^[0-9,]*$/,
    message: 'Please input correct number',
    style: { width: '46%', marginBottom: '2.5rem' },
  },
];

export const individualTargetData = [
  {
    type: 'Div',
    text: 'Please enter information about the ',
    companyName: 'Target Company.',
    name: 'SUBTWOdiv',
    style: {
      marginBottom: '1.563rem',
      color: '#DBDBDB',
      fontFamily: 'Helvetica Neue,Arial',
      fontSize: '1.375rem',
    },
  },
  {
    type: 'Input',
    label: 'Company Name',
    name: 'SUBTWOname',
    required: true,
    message: 'Company Name is required',
    style: { width: '46%' },
  },
  {
    label: 'Parent Company',
    name: 'SUBTWOparentCompany',
    ...commonAttribution,
  },
  {
    label: 'Company Website',
    name: 'SUBTWOcompanyWebsite',
    required: true,
    message: 'Company Website is required',
    ...commonAttribution,
  },
  {
    label: 'Company Description',
    name: 'SUBTWOdescription',
    ...commonAttribution,
    type: 'textArea',
  },
  {
    label: 'Industry',
    name: 'SUBTWOindustry',
    ...commonAttribution,
  },
  {
    label: 'Headquarters',
    name: 'SUBTWOheadquarters',
    ...commonAttribution,
  },
  {
    label: 'Incorporation Year',
    name: 'SUBTWOincorporationDate',
    ...commonAttribution,
  },
  {
    label: 'Employee Headcount',
    name: 'SUBTWOemployeeHeadcount',
    pattern: /^[0-9,]*$/,
    message: 'Please input correct number',
    ...commonAttribution,
  },
  {
    label: 'Estimated Total Revenue ($ US)',
    name: 'SUBTWOestimatedTotalRevenue',
    pattern: /^[0-9,]*$/,
    message: 'Please input correct number',
    ...commonAttribution,
  },

  {
    label: 'Estimated Market Cap ($ US)',
    name: 'SUBTWOestimatedMarketCap',
    type: 'Input',
    pattern: /^[0-9,]*$/,
    message: 'Please input correct number',
    style: { width: '46%', marginBottom: '2.5rem' },
  },
];

export const LIFECYCLE_HEADER_TITLES = {
  0: 'Diligence',
  '0-0': 'Assess synergies, costs, and risks',
  '0-1': 'Jumpstart the integration',
  '0-2': 'Capture key insights',
  1: 'Sign-to-Close',
  '1-0': 'Set the Course',
  '1-1': 'Plan for Day One',
  '1-2': 'Design the Future State',
  2: 'First 100 Days',
  '2-0': 'Execute 100 Day Plan',
  '2-1': 'Create detailed Integration Plan',
  3: 'Steady State',
  '3-0': 'Maximize Value through Future State Implementation',
};

export const INTEGRATION_TYPES = {
  POWER_BI: 'powerbi',
  PDF: 'pdf',
  IMG: 'image',
  OTHER: 'other',
  TEXT: 'text',
  CHART: 'chart', // chart section for project home
  WIDGET: 'widget', // chart module in project setting / manage tiles
  TEXT_CONTAINER: 'textContainer',
  MULTI_SECTION: 'multiSection',
  M365: 'M365',
  HTML: 'html',
};

const baseTypeTextMap = [
  {
    value: 'powerbi',
    typeText: 'Power BI',
  },
  {
    value: 'pdf',
    typeText: 'PDF',
  },
  {
    value: 'image',
    typeText: 'Image',
  },
  {
    value: 'text',
    typeText: 'Other',
  },
  {
    value: 'default',
    typeText: 'Default',
  },
  {
    value: 'other',
    typeText: 'Other',
  },
  {
    value: 'chart',
    typeText: 'Widget',
  },
  {
    value: 'textContainer',
    typeText: 'Text',
  },
  {
    value: INTEGRATION_TYPES.M365,
    typeText: INTEGRATION_TYPES.M365,
  },
  {
    value: 'powerbiModule',
    typeText: 'Power BI',
  },
  {
    value: 'imageModule',
    typeText: 'Image',
  },
  {
    value: INTEGRATION_TYPES.HTML,
    typeText: 'HTML',
  },
  {
    value: 'regular',
    typeText: 'Other',
  },
  {
    value: INTEGRATION_TYPES.WIDGET,
    typeText: 'Visualization Widget',
  },
  {
    value: INTEGRATION_TYPES.TEXT_CONTAINER,
    typeText: 'Text',
  },
  {
    value: INTEGRATION_TYPES.MULTI_SECTION,
    typeText: 'Multi-section',
  },
  {
    value: 'default',
    typeText: 'Default',
  },
];

export const typeTextMap = filterHtmlModuleTypeTextMap(baseTypeTextMap);

export const FixedRatios = {
  FULL: 'full',
  NONE: 'none',
  BANNER: 'banner',
  STANDARD: 'standard',
  AUTO: 'auto',
};

export const RatioSelectorOptions = [
  {
    value: FixedRatios.FULL,
    label: 'Full Size',
    description: '1280px wide by 540px high for a ratio of 64:27',
  },
  {
    value: FixedRatios.BANNER,
    label: 'Banner Size',
    description: '1280px wide by 280px high for a ratio of 32:7',
  },
  {
    value: FixedRatios.STANDARD,
    label: 'Standard Size',
    description: '1280px wide by 720px high for a ratio of 16:9',
  },
  // {
  //   value: FixedRatios.AUTO,
  //   label: 'AUTO',
  //   description: 'Fit the report to fill the available space',
  // },
];

export const DisabledRatioSelectorOptions = [
  { value: 'none', label: 'Not Applicable' },
];
